module.exports = __webpack_public_path__ + "static/media/youtube.bd7ea5fe.svg";